'use strict';

payableInvoicesController.$inject = [
	'$scope',
	'$rootScope',
	'$location',
	'$q',
	'$uibModal',
	'$filter',
	'dialogHelper',
	'dialogSearchHelper',
	'utilsService',
	'vendorService',
	'unitService',
	'apSetupService',
	'eventService',
	'siteService',
	'invoiceService',
	'employeeService',
	'accountStructureService',
	'authService',
	'ACCOUNT_TYPES',
	'INVOICE_STATUS',
	'INVOICE_SEARCH_TYPES',
	'PO_STATUS',
	'METHODS_OF_PAYMENT',
	'USER_CLAIMS',
	'ROLE_CLAIMS',
	'TAX_RATE_TYPES',
	'SOURCE',
	'ACH_SETUP',
	'BUSY_MESSAGE',
];
angular.module('schoolLinqApp').controller('payableInvoicesController', payableInvoicesController);

function payableInvoicesController(
	$scope,
	$rootScope,
	$location,
	$q,
	$uibModal,
	$filter,
	dialogHelper,
	dialogSearchHelper,
	utilsService,
	vendorService,
	unitService,
	apSetupService,
	eventService,
	siteService,
	invoiceService,
	employeeService,
	accountStructureService,
	authService,
	ACCOUNT_TYPES,
	INVOICE_STATUS,
	INVOICE_SEARCH_TYPES,
	PO_STATUS,
	METHODS_OF_PAYMENT,
	USER_CLAIMS,
	ROLE_CLAIMS,
	TAX_RATE_TYPES,
	SOURCE,
	ACH_SETUP,
	BUSY_MESSAGE
) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;
	const today = new Date();

	$q.all([
		$scope.vm.loadStates($scope.vm),
		$scope.vm.loadSites($scope.vm),
		$scope.vm.loadUsers($scope.vm),
		$scope.vm.loadAccountStructures($scope.vm),
		$scope.vm.loadMethodOfPaymentTypes($scope.vm),
		$scope.vm.loadTaxRateTypes($scope.vm),
		$scope.vm.loadInvoiceStatus($scope.vm),
		$scope.vm.loadUnitTaxRates($scope.vm),
		$scope.vm.loadEvents($scope.vm),
		$scope.vm.loadAPSetup($scope.vm),
		$scope.vm.loadCurrentFY($scope.vm),
		$scope.vm.loadInvoices($scope.vm),
		$scope.vm.loadTINTypes($scope.vm),
		$scope.vm.loadVendor1099Boxes($scope.vm),
		$scope.vm.loadNextVendorCode($scope.vm),
	]);

	function getViewModel(moduleName) {
		var fieldClaims = authService.authentication.fieldClaims;
		var denyAccrueInvoicesOnSNPOs = _.findWhere(fieldClaims, {
			ClaimValue: ROLE_CLAIMS.DenyAccrueInvoicesOnSNPOs,
		});
		var docMgmtPermission = null; // authService.hasPageClaim(payableClaims, 'ManageInvoicesDocMgmt', USER_CLAIMS.fund, 'payable');
		var model = {
			module: moduleName,
			denyAccrueInvoicesOnSNPOs: denyAccrueInvoicesOnSNPOs,
			states: [],
			events: [],
			unifiedAccountMask: null,
			expenseAccountMask: null,
			invoices: [],
			sites: [],
			invoiceStatus: [],
			methodOfPaymentTypes: [],
			methodPaymentTypesCheckboxes: [],
			taxRateTypes: [],
			backupMethodOfPaymentTypes: [],
			selectedInvoicesId: null,
			filter: {
				type: 'Date Range',
				invoiceType: 'Fund Management',
				/* Initially sort by descending invoice date, then invoice number */
				propertyName: ['-InvoiceDT', 'InvoiceNumber'],
				reverse: false,
				statusId: INVOICE_STATUS.Unpaid,
				searchType: INVOICE_SEARCH_TYPES.InvoiceSearch,
				paymentMethods: [],
				modifiedByUserName: '',
			},
			employeeFilter: {
				statusId: 1,
				name: null,
				number: null,
			},
			postalCodeMinLength: '0',
			unitTaxRates: {
				stateTaxRateGoods: 0,
				countyTaxRateGoods: 0,
				localTaxRateGoods: 0,
				stateTaxRateService: 0,
				countyTaxRateService: 0,
				localTaxRateService: 0,
				stateTaxRateFood: 0,
				countyTaxRateFood: 0,
				localTaxRateFood: 0,
			},
			apSetup: null,
			METHODS_OF_PAYMENT: METHODS_OF_PAYMENT,
			SOURCE: SOURCE,
			typeaheadLimit: 10,
			barLimit: 12,
			startIndex: 0,
			numberOfPages: [],
			newEditState: null,
			currentFY: null,
			closedMonth: null,
			errors: null,
			validationErrors: [],
			busyMessage: BUSY_MESSAGE.Loading,
			ACH_SETUP: ACH_SETUP,
			achSetupId: authService.authentication.achSetupId,
			isPayrollAccessible: false,
			isReadOnly: authService.isReadOnly(USER_CLAIMS.lsb, 'ManageInvoices', 'payable'),
			canImport: null, // authService.hasPageClaim(payableClaims, 'ManageInvoicesImport', USER_CLAIMS.fund, 'payable'),
			docMgmt: {
				permissionLevel: docMgmtPermission,
				hasConfidentialAccess:
					authService.authentication.isGA ||
					!!_.findWhere(fieldClaims, {
						ClaimValue: ROLE_CLAIMS.FundManagementAccountsPayableDocMgmtConfidential,
					}),
				hasDeleteAccess:
					authService.authentication.isGA ||
					!!_.findWhere(fieldClaims, {
						ClaimValue: ROLE_CLAIMS.FundManagementAccountsPayableDocMgmtDelete,
					}),
			},
			nextVendorCode: null,
		};

		function newEditInvoice(model, invoiceId, duplicate, readOnly) {
			$scope.vm.newEditState = 'start';
			$scope.vm.selectedInvoicesId = invoiceId;
			if (readOnly === undefined) {
				readOnly = false;
			}
			$uibModal
				.open({
					template: require('@ajs/templates/fund/payable/invoice-addedit-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					windowClass: 'app-modal-window-autoWidth',
					controller: [
						'$scope',
						'$uibModalInstance',
						'siteService',
						'vendorService',
						'accountService',
						'ACCOUNT_TYPES',
						'invoiceService',
						'purchaseOrderService',
						'unitService',
						function (
							$scope,
							modalInstance,
							siteService,
							vendorService,
							accountService,
							ACCOUNT_TYPES,
							invoiceService,
							purchaseOrderService,
							unitService
						) {
							// this will listen for route changes (like the user clicking the browsers Back button)
							// and ignore them so the user will stay on the modal.
							$scope.$on('$locationChangeStart', function (event) {
								event.preventDefault();
							});

							$scope.vm.postalCodeMinLength = '0';

							$scope.newInvoice = {
								Id: 0,
								InvoiceAccounts: [],
								InvoiceDT: today,
								PostDT: today,
								DueDT: today,
								IsPayrollInvoice: false,
								isPaid: false,
								MethodOfPaymentId: null,
								RemitTo: 'V',
								isFMACHInvoice: false,
								ShippingCost: 0,
							};

							if ($scope.vm.selectedInvoicesId) {
								model.busyMessage = BUSY_MESSAGE.Loading;
								$scope.busyPromise = $q.all([getInvoice($scope.vm.selectedInvoicesId)]);
							} else {
								// if this is a new invoice then select 'US' as the Country
								$scope.newInvoice.RemitCountry = 'US';
								// if there is only one site, select it
								if (model.sites && model.sites.length === 1) {
									$scope.newInvoice.SiteId = model.sites[0].Id;
									getSite($scope.newInvoice.SiteId);
								}
								addInvoiceTotalWatch();
							}

							function addInvoiceTotalWatch() {
								$scope.invoiceGrandTotal = 0;
								$scope.$watch('invoiceGrandTotal', function (newValue, oldValue) {
									if (oldValue !== newValue) {
										$scope.syncShippingCost();
									}
								});
							}

							function getInvoice(invoiceId) {
								return invoiceService.getInvoice(invoiceId).then(finishGettingInvoice);

								function finishGettingInvoice(response) {
									if (duplicate) {
										$scope.newInvoice = response.data;
										$scope.newInvoice.Id = 0;
										$scope.newInvoice.InvoiceNumber = null;
										$scope.newInvoice.PurchaseOrder = null;
										$scope.newInvoice.PostDT = today;
										$scope.newInvoice.DueDT = today;
										$scope.newInvoice.InvoiceDT = today;
										$scope.newInvoice.StatusId = INVOICE_STATUS.Unpaid;
										$scope.newInvoice.isPaid = false;
										$scope.newInvoice.isFMACHInvoice = false;

										angular.forEach($scope.newInvoice.InvoiceAccounts, function (account) {
											account.Id = 0;
											account.InvoiceId = 0;
											angular.forEach(account.InvoiceLines, function (line) {
												line.Id = 0;
												line.InvoiceId = 0;
												line.POLineId = null;
												line.POQuantity = null;
												line.poUsed = null;
											});
										});
									} else {
										$scope.newInvoice = response.data;
										$scope.newInvoice.PostDT = new Date($scope.newInvoice.PostDT);
										$scope.newInvoice.DueDT = new Date($scope.newInvoice.DueDT);
										$scope.newInvoice.InvoiceDT = new Date($scope.newInvoice.InvoiceDT);
										$scope.newInvoice.isPaid = $scope.newInvoice.StatusId === INVOICE_STATUS.Paid;
									}

									if ($scope.newInvoice.Vendor.Id === 0) {
										$scope.newInvoice.Vendor = null;
									} else {
										$scope.newInvoice.RemitTo = 'V';
										$scope.loadVendorMethodOfPaymentTypes($scope.newInvoice.Vendor);
									}
									if ($scope.newInvoice.Employee.EmployeeNumber === null) {
										$scope.newInvoice.Employee = null;
									} else {
										$scope.newInvoice.RemitTo = 'E';
										$scope.loadEmployeeMethodOfPaymentTypes($scope.newInvoice.Employee);
									}

									// If S&H was handled the old way we need to set S&H total
									if (!$scope.newInvoice.ShippingCost) {
										if (!$scope.newInvoice.InvoiceAccounts) {
											$scope.newInvoice.ShippingCost = 0;
										} else {
											$scope.newInvoice.ShippingCost = _.reduce(
												$scope.newInvoice.InvoiceAccounts,
												function (num, account) {
													return (
														num +
														_.reduce(
															account.InvoiceLines,
															function (num, line) {
																return num + (line.IsShipping ? parseFloat(line.Amount) : 0);
															},
															0
														)
													);
												},
												0
											);

											// if unpaid remove the line items for them
											if ($scope.newInvoice.StatusId === INVOICE_STATUS.Unpaid) {
												angular.forEach($scope.newInvoice.InvoiceAccounts, function (account) {
													filterOutShippingAndHandling(account);
												});
											}
										}
									}

									$scope.newInvoice.ReadOnly = model.isReadOnly;
									$scope.newInvoice.ReadOnlyEvent = model.isReadOnly;

									if (
										readOnly === true ||
										$scope.newInvoice.IsPayrollInvoice ||
										$scope.newInvoice.isPaid ||
										$scope.newInvoice.StatusId === INVOICE_STATUS.PartialPaid ||
										$scope.newInvoice.StatusId === INVOICE_STATUS.Paid ||
										$scope.newInvoice.StatusId === INVOICE_STATUS.Deleted ||
										$scope.newInvoice.SourceId === SOURCE.SummerPay
									) {
										$scope.newInvoice.ReadOnly = true;
										if (
											readOnly === true ||
											$scope.newInvoice.IsPayrollInvoice ||
											$scope.newInvoice.StatusId === INVOICE_STATUS.Deleted
										)
											$scope.newInvoice.ReadOnlyEvent = true;
									}
									if (
										model.denyAccrueInvoicesOnSNPOs &&
										$scope.newInvoice.PurchaseOrder &&
										$scope.newInvoice.PurchaseOrder.SourceId === SOURCE.MealsPlus
									) {
										$scope.newInvoice.ReadOnly = true;
										$scope.newInvoice.ReadOnlyEvent = true;
									}
									if ($scope.newInvoice.isFMACHInvoice === true) {
										$scope.newInvoice.ReadOnly = true;
										$scope.newInvoice.ReadOnlyEvent = true;
									}

									$scope.newInvoice.CanEditPRPaymentBy = false;
									if (
										readOnly === false &&
										model.isReadOnly === false &&
										$scope.newInvoice.IsPayrollInvoice === true &&
										$scope.newInvoice.StatusId !== INVOICE_STATUS.PartialPaid &&
										$scope.newInvoice.StatusId !== INVOICE_STATUS.Paid &&
										$scope.newInvoice.StatusId !== INVOICE_STATUS.Deleted
									) {
										$scope.newInvoice.CanEditPRPaymentBy = true;
									}

									$scope.newInvoice.CanEditFMACHPaymentBy = false;
									if (
										readOnly === false &&
										model.isReadOnly === false &&
										$scope.newInvoice.isFMACHInvoice === true &&
										$scope.newInvoice.StatusId !== INVOICE_STATUS.PartialPaid &&
										$scope.newInvoice.StatusId !== INVOICE_STATUS.Paid &&
										$scope.newInvoice.StatusId !== INVOICE_STATUS.Deleted
									) {
										$scope.newInvoice.CanEditFMACHPaymentBy = true;
									}

									// if there is no RemitCountry on this invoice then select 'US' as the Country as a default.
									if (!$scope.newInvoice.RemitCountry) {
										$scope.newInvoice.RemitCountry = 'US';
									}

									if ($scope.newInvoice.ShippingCost > 0 && $scope.newInvoice.StatusId === INVOICE_STATUS.Unpaid) {
										// Need to ensure the sum of line shippingCosts equals entered shipping cost.
										if ($scope.totalCalculatedSH() !== Number($scope.newInvoice.ShippingCost) && !model.ReadOnly) {
											$scope.syncShippingCost(true);
										}
									}

									addInvoiceTotalWatch();

									return angular.noop;
								}
							}

							function filterOutShippingAndHandling(account) {
								if (account.InvoiceLines) {
									account.InvoiceLines = account.InvoiceLines.filter(function (x) {
										return !x.IsShipping;
									});
								}
							}

							function getSite(siteId) {
								return siteService.getSite(siteId).then(finishLoadingSite);

								function finishLoadingSite(response) {
									$scope.newInvoice.SiteId = response.data.site.Id;
									$scope.newInvoice.ShipTo = response.data.site.SiteCode + ' ' + response.data.site.SiteName;
									$scope.newInvoice.ShipToName = response.data.site.ShipToName;
									$scope.newInvoice.ShipAttn = response.data.site.ShipToAttn;
									$scope.newInvoice.ShipAddress1 = response.data.site.ShipToAddress1;
									$scope.newInvoice.ShipAddress2 = response.data.site.ShipToAddress2;
									$scope.newInvoice.ShipCity = response.data.site.ShipToCity;
									$scope.newInvoice.ShipState = response.data.site.ShipToState;
									$scope.newInvoice.ShipZip = response.data.site.ShipToZip;
									$scope.newInvoice.Site = response.data.site;
									return angular.noop;
								}
							}

							angular.extend($scope, {
								disableSave: function () {
									return !$scope.invoiceForm.$dirty;
								},
								done: function () {
									modalInstance.close();
								},
								cancel: function () {
									model.validationErrors = [];
									modalInstance.close();
								},
								removeAccount: function (index) {
									$scope.newInvoice.InvoiceAccounts.splice(index, 1);
									$scope.invoiceForm.$setDirty();
								},
								getNewLine: function () {
									let newLine = {
										Id: 0,
										Quantity: 0,
										UnitCost: 0,
										IsShipping: false,
										IsDiscount: false,
										TaxRateTypeId:
											$scope.newInvoice.RemitTo === 'V'
												? parseInt(TAX_RATE_TYPES.Goods) || 1
												: parseInt(TAX_RATE_TYPES.Service) || 2,
										IsPercent: false,
										AmountPercent: 0,
										TotalTax: 0,
										EventId: 0,
										Event: { Id: 0, EventCode: '', EventName: '' },
									};
									$scope.changeTaxType(newLine);

									return newLine;
								},
								addAccount: function () {
									$scope.newInvoice.InvoiceAccounts.push({
										Id: 0,
										InvoiceLines: [$scope.getNewLine()],
									});
								},
								addLine: function (account) {
									account.InvoiceLines.push($scope.getNewLine());
								},
								removeLine: function (account, line) {
									let index = _.findIndex(account.InvoiceLines, {
										$$hashKey: line.$$hashKey,
									});
									account.InvoiceLines.splice(index, 1);
									$scope.invoiceForm.$setDirty();
								},
								removeInvoiceDiscount: function (line) {
									let index = _.findIndex($scope.newInvoice.InvoiceDiscounts, {
										$$hashKey: line.$$hashKey,
									});
									$scope.newInvoice.InvoiceDiscounts.splice(index, 1);
									$scope.invoiceForm.$setDirty();
								},
								getEventName: function (line) {
									let event = _.find(model.events, function (events) {
										return events.Id === line.EventId;
									});
									line.Event.EventName = event.EventName;
								},
								hasShipping: function (account) {
									var hasShipping = _.findWhere(account.InvoiceLines, {
										IsShipping: true,
									});
									return hasShipping ? true : false;
								},
								addDiscount: function (account) {
									account.InvoiceLines.push({
										Id: 0,
										Quantity: 1,
										Unit: 'DC',
										Description: 'Discount',
										TaxRateTypeId: parseInt(TAX_RATE_TYPES.Goods) || 1,
										UnitCost: 0,
										StateTaxRate: $scope.newInvoice.Vendor
											? $scope.newInvoice.Vendor.StateTaxRateGoods
											: model.unitTaxRates.stateTaxRateGoods,
										CountyTaxRate: $scope.newInvoice.Vendor
											? $scope.newInvoice.Vendor.CountyTaxRateGoods
											: model.unitTaxRates.countyTaxRateGoods,
										LocalTaxRate: $scope.newInvoice.Vendor
											? $scope.newInvoice.Vendor.LocalTaxRateGoods
											: model.unitTaxRates.localTaxRateGoods,
										IsDiscount: true,
										IsPercent: false,
										IsShipping: false,
										AmountPercent: 0,
										TotalTax: 0,
										EventId: 0,
										Event: { Id: 0, EventCode: '', EventName: '' },
									});
								},
								getDiscountType: function (account) {
									var discount = _.where(account.PurchaseOrderLines, {
										IsDiscount: true,
									})[0];
									return discount && parseInt(discount.TaxRateTypeId) === parseInt(TAX_RATE_TYPES.Goods)
										? parseInt(TAX_RATE_TYPES.Service)
										: parseInt(TAX_RATE_TYPES.Goods);
								},
								onAmountPercentTypeChange: function (line) {
									line.UnitCost = 0;
									line.AmountPercent = 0;
								},
								onAmountPercentKeyDown: function (event, line) {
									const keyCode = event.keyCode;
									// 32 = space, 13 = enter

									if (keyCode == 13) {
										line.IsPercent = !line.IsPercent;
										event.preventDefault();
									}
								},
								hasDiscounts: function (account) {
									var discounts = _.where(account.InvoiceLines, {
										IsDiscount: true,
									});
									return discounts && discounts.length > 1 ? true : false;
								},
								addInvoiceDiscount: function () {
									if (!$scope.newInvoice.InvoiceDiscounts) {
										$scope.newInvoice.InvoiceDiscounts = [];
									}
									$scope.newInvoice.InvoiceDiscounts.push({
										Id: 0,
										UnitCost: 0,
										Quantity: 1,
										Unit: 'IDC',
										Description: 'Invoice Discount',
										TaxRateTypeId: parseInt(TAX_RATE_TYPES.Goods) || 1,
										StateTaxRate: $scope.newInvoice.Vendor
											? $scope.newInvoice.Vendor.StateTaxRateGoods
											: model.unitTaxRates.stateTaxRateGoods,
										CountyTaxRate: $scope.newInvoice.Vendor
											? $scope.newInvoice.Vendor.CountyTaxRateGoods
											: model.unitTaxRates.countyTaxRateGoods,
										LocalTaxRate: $scope.newInvoice.Vendor
											? $scope.newInvoice.Vendor.LocalTaxRateGoods
											: model.unitTaxRates.localTaxRateGoods,
										IsPercent: false,
										AmountPercent: 0,
										TotalTax: 0,
									});
								},
								isRemitStateAndZipRequired: function () {
									if ($scope.newInvoice.RemitCountry === 'US') {
										$scope.vm.postalCodeMinLength = '0';
										return true;
									}
									return false;
								},
								isRemitProvinceAndPostalCodeRequired: function () {
									if ($scope.newInvoice.RemitCountry === 'CA') {
										$scope.vm.postalCodeMinLength = '6';
										return true;
									}
									if ($scope.newInvoice.RemitCountry === 'UK') {
										$scope.vm.postalCodeMinLength = '6';
										return true;
									}
									return false;
								},
								handleVendorSelected: function () {
									$scope.newInvoice.RemitTo = 'V';
									$scope.newInvoice.Employee = null;
									$scope.newInvoice.RemitAttn = null;
									$scope.newInvoice.RemitCountry = 'US';
									$scope.newInvoice.RemitAddress1 = null;
									$scope.newInvoice.RemitAddress2 = null;
									$scope.newInvoice.RemitCity = null;
									$scope.newInvoice.RemitState = null;
									$scope.newInvoice.RemitZip = null;
									$scope.newInvoice.MethodOfPaymentId = null;
									$scope.loadVendorMethodOfPaymentTypes(null);
								},
								handleEmployeeSelected: function () {
									$scope.newInvoice.RemitTo = 'E';
									$scope.newInvoice.Vendor = null;
									$scope.newInvoice.RemitAttn = null;
									$scope.newInvoice.RemitCountry = 'US';
									$scope.newInvoice.RemitAddress1 = null;
									$scope.newInvoice.RemitAddress2 = null;
									$scope.newInvoice.RemitCity = null;
									$scope.newInvoice.RemitState = null;
									$scope.newInvoice.RemitZip = null;
									$scope.newInvoice.MethodOfPaymentId = null;
									$scope.newInvoice.InvoiceAccounts.forEach((account) => {
										account.InvoiceLines = account.InvoiceLines.filter((line) => !line.IsShipping);
										account.InvoiceLines.forEach((line) => {
											line.TaxRateTypeId = parseInt(TAX_RATE_TYPES.Service);
											$scope.changeTaxType(line);
											$scope.lineTax(line);
										});
									});
									$scope.newInvoice.TotalTax = 0;
									$scope.newInvoice.ShippingCost = 0;
									$scope.loadEmployeeMethodOfPaymentTypes(null);
								},
								changeTaxType: function (line) {
									switch (parseInt(line.TaxRateTypeId) || 1) {
										case parseInt(TAX_RATE_TYPES.Service):
											// Service
											line.StateTaxRate = $scope.newInvoice.Vendor
												? $scope.newInvoice.Vendor.StateTaxRateService
												: model.unitTaxRates.stateTaxRateService;
											line.CountyTaxRate = $scope.newInvoice.Vendor
												? $scope.newInvoice.Vendor.CountyTaxRateService
												: model.unitTaxRates.countyTaxRateService;
											line.LocalTaxRate = $scope.newInvoice.Vendor
												? $scope.newInvoice.Vendor.LocalTaxRateService
												: model.unitTaxRates.localTaxRateService;
											break;

										case parseInt(TAX_RATE_TYPES.Food):
											// Food
											line.StateTaxRate = $scope.newInvoice.Vendor
												? $scope.newInvoice.Vendor.StateTaxRateFood
												: model.unitTaxRates.stateTaxRateFood;
											line.CountyTaxRate = $scope.newInvoice.Vendor
												? $scope.newInvoice.Vendor.CountyTaxRateFood
												: model.unitTaxRates.countyTaxRateFood;
											line.LocalTaxRate = $scope.newInvoice.Vendor
												? $scope.newInvoice.Vendor.LocalTaxRateFood
												: model.unitTaxRates.localTaxRateFood;
											break;

										default:
											// Goods
											line.StateTaxRate = $scope.newInvoice.Vendor
												? $scope.newInvoice.Vendor.StateTaxRateGoods
												: model.unitTaxRates.stateTaxRateGoods;
											line.CountyTaxRate = $scope.newInvoice.Vendor
												? $scope.newInvoice.Vendor.CountyTaxRateGoods
												: model.unitTaxRates.countyTaxRateGoods;
											line.LocalTaxRate = $scope.newInvoice.Vendor
												? $scope.newInvoice.Vendor.LocalTaxRateGoods
												: model.unitTaxRates.localTaxRateGoods;
											break;
									}
								},
								editTax: function (line) {
									$scope.selectedLine = line;
									$uibModal
										.open({
											template: require('@ajs/templates/fund/payable/invoice-taxupdate-modal.html'),
											backdrop: 'static',
											keyboard: false,
											scope: $scope,
											controller: [
												'$scope',
												'$uibModalInstance',
												function ($scope, modalInstance) {
													$scope.tempState = angular.copy($scope.selectedLine.StateTaxRate);
													$scope.tempCounty = angular.copy($scope.selectedLine.CountyTaxRate);
													$scope.tempLocal = angular.copy($scope.selectedLine.LocalTaxRate);

													angular.extend($scope, {
														taxCancel: function () {
															modalInstance.close();
														},
														updateTax: function () {
															if (!$scope.taxUpdateForm.$valid) {
																return;
															}
															modalInstance.close({
																state: $scope.tempState,
																county: $scope.tempCounty,
																local: $scope.tempLocal,
															});
														},
													});
												},
											],
										})
										.result.then(function (updatedTaxes) {
											if (updatedTaxes) {
												$scope.selectedLine.StateTaxRate = updatedTaxes.state;
												$scope.selectedLine.CountyTaxRate = updatedTaxes.county;
												$scope.selectedLine.LocalTaxRate = updatedTaxes.local;
												$scope.lineTax(line);
												$scope.newInvoice.TotalTax = $scope.totalTax();
												$scope.invoiceForm.$setDirty();
											}
										});
								},
								lineAmount: function (line) {
									line.Amount = emsRound(line.Quantity * line.UnitCost) || 0;
									return line.Amount;
								},
								lineDiscountAmount: function (account, discount) {
									switch (discount.IsPercent) {
										case true:
											const lines = account.InvoiceLines.filter(
												(i) =>
													!i.IsDiscount && !i.IsShipping && parseInt(i.TaxRateTypeId) === parseInt(discount.TaxRateTypeId)
											);
											const merchTotal = _.reduce(
												lines,
												function (total, line) {
													return parseFloat(total + line.Amount);
												},
												0
											);

											discount.UnitCost = emsRound(emsRound(Math.abs(discount.AmountPercent) / 100) * merchTotal, 4) * -1;

											break;
										default:
											discount.UnitCost = Math.abs(discount.AmountPercent) * -1;
											break;
									}
									discount.Amount = emsRound(discount.Quantity * discount.UnitCost) || 0;
									return discount.Amount;
								},
								lineInvoiceDiscountAmount: function (line) {
									switch (line.IsPercent) {
										case true:
											let lines = [];
											$scope.newInvoice.InvoiceAccounts.forEach((x) => {
												const invoiceLines = x.InvoiceLines.filter(
													(i) =>
														!i.IsDiscount && !i.IsShipping && parseInt(i.TaxRateTypeId) === parseInt(line.TaxRateTypeId)
												);
												if (invoiceLines) {
													invoiceLines.forEach((y) => {
														lines.push(y);
													});
												}
											});
											const merchTotal = _.reduce(
												lines,
												function (total, line) {
													return parseFloat(total + line.Amount);
												},
												0
											);
											line.UnitCost = emsRound(emsRound(Math.abs(line.AmountPercent) / 100) * merchTotal, 4) * -1;

											break;
										default:
											line.UnitCost = Math.abs(line.AmountPercent) * -1;
											break;
									}
									line.Amount = emsRound(line.Quantity * line.UnitCost) || 0;
									return line.Amount;
								},

								lineTax: function (line) {
									if (line.Amount > 0 || line.IsDiscount === true) {
										// need to add in the shipping cost tax here by calculating percentages.
										// the shipping cost for each line is calculated every time the grand total changes
										// for the invoice.  After shipping is calculated, this function is called to
										// calculate the taxes on the Shipping allocated to this line.

										if (!_.isNumber(line.ShippingCost)) {
											line.ShippingCost = 0;
										}

										const lineStateShippingTax = calculateRoundedTax(line.ShippingCost, line.StateTaxRate);
										const lineCountyShippingTax = calculateRoundedTax(line.ShippingCost, line.CountyTaxRate);
										const lineLocalShippingTax = calculateRoundedTax(line.ShippingCost, line.LocalTaxRate);

										const stateTax = calculateRoundedTax(line.Amount, line.StateTaxRate);
										const countyTax = calculateRoundedTax(line.Amount, line.CountyTaxRate);
										const localTax = calculateRoundedTax(line.Amount, line.LocalTaxRate);

										// each tax amount should be rounded to 2 decimal places before being summed together for the final total
										line.TotalTax =
											stateTax + lineStateShippingTax + countyTax + lineCountyShippingTax + localTax + lineLocalShippingTax;

										line.TotalTax = emsRound(line.TotalTax * 100) / 100;
									} else {
										line.TotalTax = 0;
									}
									return line.TotalTax;
								},
								lineTotal: function (line) {
									line.LineTotal =
										emsRound(line.TotalTax + parseFloat(line.Amount) + (line.ShippingCost ? parseFloat(line.ShippingCost) : 0)) ||
										0;
									return line.LineTotal;
								},
								accountTotal: function (account) {
									return _.reduce(
										account.InvoiceLines,
										function (num, line) {
											return emsRound(num + parseFloat(line.Amount));
										},
										0
									);
								},
								subTotal: function () {
									if (!$scope.newInvoice.InvoiceAccounts) return 0;
									return _.reduce(
										$scope.newInvoice.InvoiceAccounts,
										function (num, account) {
											return (
												num +
												_.reduce(
													account.InvoiceLines,
													function (num, line) {
														return num + (!line.IsShipping ? parseFloat(line.Amount) : 0);
													},
													0
												)
											);
										},
										0
									);
								},
								totalInvoiceDiscounts: function () {
									if (!$scope.newInvoice.InvoiceDiscounts) return 0;
									return _.reduce(
										$scope.newInvoice.InvoiceDiscounts,
										function (num, discountLine) {
											return num + parseFloat(discountLine.Amount);
										},
										0
									);
								},
								totalTax: function () {
									if (!$scope.newInvoice.InvoiceAccounts) return 0;
									return _.reduce(
										$scope.newInvoice.InvoiceAccounts,
										function (num, account) {
											return _.reduce(
												account.InvoiceLines,
												function (num, line) {
													return num + line.TotalTax;
												},
												num
											);
										},
										0
									);
								},

								/*
									This function returns the sum of shipping costs allocated across the invoice lines.
								*/
								totalCalculatedSH: function () {
									if (!$scope.newInvoice.InvoiceAccounts) return 0;
									const totalSH = _.reduce(
										$scope.newInvoice.InvoiceAccounts,
										function (num, account) {
											return (
												num +
												_.reduce(
													account.InvoiceLines,
													function (num, line) {
														return num + parseFloat(line.ShippingCost);
													},
													0
												)
											);
										},
										0
									);
									return emsRound(totalSH);
								},

								/*
									This function calculates and sets the Shipping Cost for the invoice line passed in.
								*/
								setCalculatedShippingCost: function (line) {
									const linePercentage = line.Amount / $scope.subTotal();
									const lineShippingCost = emsRound($scope.newInvoice.ShippingCost * linePercentage);
									line.ShippingCost = lineShippingCost;
								},

								/*
									This function ensures the Total for Shipping Costs across Invoice Lines
									equals the entered Shipping and Handling value for the Invoice.
								*/
								syncShippingCost: function (makeFormDirty = false) {
									_.each($scope.newInvoice.InvoiceAccounts, function (account) {
										_.each(account.InvoiceLines, function (line) {
											$scope.setCalculatedShippingCost(line);
										});
									});

									if (makeFormDirty) {
										$scope.invoiceForm.$setDirty();
									}

									if ($scope.totalCalculatedSH() !== Number($scope.newInvoice.ShippingCost)) {
										let outage = emsRound(parseFloat($scope.totalCalculatedSH() - Number($scope.newInvoice.ShippingCost)));
										if (outage !== 0) {
											_.each($scope.newInvoice.InvoiceAccounts, function (account) {
												const lines = account.InvoiceLines.filter((f) => f.Amount > 0 && !f.IsDiscount && !f.IsShipping);
												_.each(
													lines.sort((a, b) => b.Amount - a.Amount),
													function (sortedLine) {
														const line = _.find(account.InvoiceLines, function (f) {
															return f === sortedLine;
														});
														if (!_.isUndefined(line) && outage !== 0) {
															const increment = outage > 0 ? -0.01 : 0.01;
															line.ShippingCost = emsRound(line.ShippingCost + increment);
															// Increment was causing the decimal place to become corrupted
															// Needs to be rounded and put to a 2 decimal place number
															outage = emsRound(outage + increment);
														}
													}
												);
											});
										}
									}
								},

								grandTotal: function () {
									if (!$scope.newInvoice.InvoiceAccounts) {
										$scope.invoiceGrandTotal = 0;
									} else {
										$scope.invoiceGrandTotal =
											$scope.subTotal() +
											($scope.newInvoice.ShippingCost ? parseFloat($scope.newInvoice.ShippingCost) : 0) +
											$scope.totalInvoiceDiscounts() +
											($scope.newInvoice.TotalTax ? parseFloat($scope.newInvoice.TotalTax) : 0);
									}
									return $scope.invoiceGrandTotal;
								},
								confirmAccount: function (account) {
									if (!account.Account.IsPRAccount) {
										account.AccountId = account.Account.Id;
										return;
									}

									return $uibModal
										.open({
											template: require('@ajs/templates/message-box-dialog.html'),
											backdrop: 'static',
											keyboard: false,
											scope: $scope,
											controller: [
												'$scope',
												'$uibModalInstance',
												function ($scope, msgBoxInstance) {
													$scope.msgBox = {
														Title: 'Confirm Account Number',
														MessageMain: 'Account Number ' + account.Account.AccountNumber + ' is a Payroll account.',
														MessageOther: 'Do you want to continue?',
														MessageImage: 'Question',
														Buttons: [
															{
																Caption: 'NO',
																Style: 'btn-cancelSave',
															},
															{
																Caption: 'YES',
																Style: 'btn-save',
															},
														],
													};

													angular.extend($scope, {
														button1: function () {
															// NO
															msgBoxInstance.close(false);
														},
														button2: function () {
															// YES
															msgBoxInstance.close(true);
														},
													});
												},
											],
										})
										.result.then(function (returnVal) {
											if (returnVal === true) account.AccountId = account.Account.Id;
											else {
												account.AccountId = undefined;
												account.Account = undefined;
											}
											return returnVal;
										});
								},
								searchAccountsbyAccountNumber: function (value, limit) {
									let typeaheadLimit = limit || $scope.vm.typeaheadLimit;
									// TFS 852 - temp fix; just allow all account types in list.
									return accountService.searchFundAccount(null, '', value, typeaheadLimit, true).then(finishSearchAccounts);

									function finishSearchAccounts(response) {
										if (response.data.accounts.length === 0) {
											return accountService
												.searchPayrollAccount(null, '', value, typeaheadLimit, true)
												.then(finishSearchPayrollAccounts);
										} else {
											return response.data.accounts;
										}
									}

									function finishSearchPayrollAccounts(response) {
										if (response.data.accounts.length === 1) {
											return response.data.accounts;
										} else {
											return angular.noop;
										}
									}
								},
								showDialogSearchHelperAccounts: function (item) {
									let modalConfig = {
										useSearchFundAccount: true,
										allowAddNew: true,
										moduleName: $scope.vm.module,
									};

									let selectFunction = function (account) {
										item.AccountId = account.Id;
										item.Account = {};
										item.Account.Id = account.Id;
										item.Account.AccountNumber = account.AccountNumber;
										item.Account.Description = account.Description;
										$scope.invoiceForm.$setDirty();
									};

									dialogSearchHelper.searchAccounts(modalConfig, selectFunction);
								},
								showDialogSearchHelperVendorsEmployees: function () {
									let modalConfig = null;
									let selectFunction = null;

									if ($scope.newInvoice.RemitTo === 'V') {
										selectFunction = function (vendor) {
											$scope.busyPromise = $scope.getVendor(vendor.Id);
										};

										dialogSearchHelper.searchVendors(modalConfig, selectFunction);
									} else {
										selectFunction = function (employee) {
											$scope.busyPromise = $scope.getEmployee(employee.Id);
										};

										dialogSearchHelper.searchEmployees(modalConfig, selectFunction);
									}
								},
								searchPObyPONumber: function (value) {
									return purchaseOrderService
										.searchPurchaseOrdersByNumber({
											poNumber: value,
											statusId: PO_STATUS.Open,
											limit: $scope.vm.typeaheadLimit,
										})
										.then(finishSearchPOs);

									function finishSearchPOs(response) {
										return response.data;
									}
								},
								getPO: function (poId) {
									model.busyMessage = BUSY_MESSAGE.Loading;
									$scope.busyPromise = purchaseOrderService.getPurchaseOrder(poId).then(finishLoadingPurchaseOrder);

									function finishLoadingPurchaseOrder(response) {
										$scope.newInvoice.PurchaseOrder = response.data.purchaseOrder;
										$scope.newInvoice.POId = response.data.purchaseOrder.Id;

										// Load Vendor from PO
										$scope.newInvoice.VendorId = response.data.purchaseOrder.Vendor.Id;
										$scope.newInvoice.RemitCountry = response.data.purchaseOrder.Vendor.RemitCountry;
										if (!$scope.newInvoice.RemitCountry) {
											// if there is no Country then select 'US' as the Country
											$scope.newInvoice.RemitCountry = 'US';
										}

										$scope.newInvoice.RemitAttn = response.data.purchaseOrder.Vendor.RemitAttn;
										$scope.newInvoice.RemitAddress1 = response.data.purchaseOrder.Vendor.RemitAddress1;
										$scope.newInvoice.RemitAddress2 = response.data.purchaseOrder.Vendor.RemitAddress2;
										$scope.newInvoice.RemitCity = response.data.purchaseOrder.Vendor.RemitCity;
										$scope.newInvoice.RemitState = response.data.purchaseOrder.Vendor.RemitState;
										$scope.newInvoice.RemitZip = response.data.purchaseOrder.Vendor.RemitZip;
										$scope.newInvoice.Vendor = response.data.purchaseOrder.Vendor;
										$scope.newInvoice.MethodOfPaymentId =
											response.data.purchaseOrder.Vendor.MethodOfPaymentId === null
												? model.METHODS_OF_PAYMENT.Check
												: response.data.purchaseOrder.Vendor.MethodOfPaymentId;
										$scope.loadVendorMethodOfPaymentTypes($scope.newInvoice.Vendor);

										// Load Site from PO
										$scope.newInvoice.SiteId = response.data.purchaseOrder.Site.Id;
										$scope.newInvoice.ShipTo = response.data.purchaseOrder.ShipTo;
										$scope.newInvoice.ShipToName = response.data.purchaseOrder.ShipToName;
										$scope.newInvoice.ShipAttn = response.data.purchaseOrder.ShipAttn;
										$scope.newInvoice.ShipAddress1 = response.data.purchaseOrder.ShipAddress1;
										$scope.newInvoice.ShipAddress2 = response.data.purchaseOrder.ShipAddress2;
										$scope.newInvoice.ShipCity = response.data.purchaseOrder.ShipCity;
										$scope.newInvoice.ShipState = response.data.purchaseOrder.ShipState;
										$scope.newInvoice.ShipZip = response.data.purchaseOrder.ShipZip;
										$scope.newInvoice.Site = response.data.purchaseOrder.Site;

										let totalTax = 0;
										let shippingCost = 0;

										// Load Accounts from PO
										$scope.newInvoice.InvoiceAccounts = _.map(
											response.data.purchaseOrder.PurchaseOrderAccounts,
											function (account) {
												return {
													Account: account.Account,
													AccountId: account.AccountId,
													IsFromPO: (account.PurchaseOrderLines.length || 0) > 0,
													InvoiceLines: _.filter(
														_.map(account.PurchaseOrderLines, function (poLine) {
															let quantity = poLine.Quantity - poLine.QuantityReceived;
															quantity = quantity > 0 ? quantity : 0;
															var newLine = poLine;
															newLine.POLineId = poLine.Id;
															newLine.POQuantity = quantity;
															newLine.poUsed = poLine.QuantityReceived;
															newLine.Quantity = quantity;
															totalTax += parseFloat(poLine.TotalTax) - parseFloat(poLine.STAmountReceived);
															shippingCost += parseFloat(poLine.ShippingCost) - parseFloat(poLine.ShippingCostReceived);
															delete newLine.Id;
															return newLine;
														}),
														function (poLine) {
															return typeof poLine !== 'undefined';
														}
													),
												};
											}
										);

										// Load Comments from PO
										$scope.newInvoice.Memo = response.data.purchaseOrder.Memo;

										$scope.newInvoice.ShippingCost = shippingCost;

										$scope.newInvoice.TotalTax = totalTax;

										return angular.noop;
									}
								},
								selectCountry: function (country) {
									if (!$scope.newInvoice.isPaid) {
										$scope.newInvoice.RemitCountry = country;
										$scope.newInvoice.RemitState = null;
										$scope.newInvoice.RemitZip = null;
									}
								},
								getVendor: function (vendorId) {
									return vendorService.getVendor(vendorId).then(finishLoadingVendor);

									function finishLoadingVendor(response) {
										$scope.newInvoice.VendorId = response.data.vendor.Id;
										$scope.newInvoice.RemitAttn = response.data.vendor.RemitAttn;
										$scope.newInvoice.RemitCountry = response.data.vendor.RemitCountry;
										if (!$scope.newInvoice.RemitCountry) {
											// if there is no Country then select 'US' as the Country
											$scope.newInvoice.RemitCountry = 'US';
										}
										$scope.newInvoice.RemitAddress1 = response.data.vendor.RemitAddress1;
										$scope.newInvoice.RemitAddress2 = response.data.vendor.RemitAddress2;
										$scope.newInvoice.RemitCity = response.data.vendor.RemitCity;
										$scope.newInvoice.RemitState = response.data.vendor.RemitState;
										$scope.newInvoice.RemitZip = response.data.vendor.RemitZip;
										$scope.newInvoice.Vendor = response.data.vendor;
										$scope.newInvoice.MethodOfPaymentId =
											response.data.vendor.MethodOfPaymentId === null
												? model.METHODS_OF_PAYMENT.Check
												: response.data.vendor.MethodOfPaymentId;
										$scope.loadVendorMethodOfPaymentTypes($scope.newInvoice.Vendor);

										// After selecting a vendor we need to loop over the Items in the Invoice to fix the Taxes
										angular.forEach($scope.newInvoice.InvoiceAccounts, function (account) {
											angular.forEach(account.InvoiceLines, function (line) {
												$scope.changeTaxType(line);
											});
										});

										return angular.noop;
									}
								},
								getEmployee: function (employeeId) {
									return employeeService.get(employeeId).then(finishLoadingEmployee);

									function finishLoadingEmployee(response) {
										$scope.newInvoice.EmployeeId = response.data.employee.Id;
										$scope.newInvoice.RemitAttn = response.data.employee.FormattedFormalName;
										$scope.newInvoice.RemitCountry = response.data.employee.Country;
										if (!$scope.newInvoice.RemitCountry) {
											// if there is no Country then select 'US' as the Country
											$scope.newInvoice.RemitCountry = 'US';
										}
										$scope.newInvoice.RemitAddress1 = response.data.employee.Address1;
										$scope.newInvoice.RemitAddress2 = response.data.employee.Address2;
										$scope.newInvoice.RemitCity = response.data.employee.City;
										$scope.newInvoice.RemitState = response.data.employee.State;
										$scope.newInvoice.RemitZip = response.data.employee.Zip;
										$scope.newInvoice.Employee = response.data.employee;
										$scope.newInvoice.MethodOfPaymentId = null;
										$scope.loadEmployeeMethodOfPaymentTypes($scope.newInvoice.Employee);

										// After selecting an employee we need to loop over the Items in the Invoice to fix the Taxes
										angular.forEach($scope.newInvoice.InvoiceAccounts, function (account) {
											angular.forEach(account.InvoiceLines, function (line) {
												$scope.changeTaxType(line);
											});
										});

										return angular.noop;
									}
								},
								loadVendorMethodOfPaymentTypes: function (vendor) {
									model.methodOfPaymentTypes = angular.copy(model.backupMethodOfPaymentTypes);
									if (vendor && (!vendor.DirectDepositBankId || !vendor.BankAccountTypeId || !vendor.AccountNumber)) {
										// no direct deposit bank set, remove ACH option
										model.methodOfPaymentTypes = _.filter(model.methodOfPaymentTypes, function (type) {
											return type.Id !== model.METHODS_OF_PAYMENT.ACH;
										});
									}
									if (vendor && $scope.newInvoice.IsPayrollInvoice) {
										// payroll invoice, remove ACH option
										model.methodOfPaymentTypes = _.filter(model.methodOfPaymentTypes, function (type) {
											return type.Id !== model.METHODS_OF_PAYMENT.ACH;
										});
									}
									if ($scope.newInvoice.isFMACHInvoice) {
										// FM ACH invoice, remove ACH option
										model.methodOfPaymentTypes = _.filter(model.methodOfPaymentTypes, function (type) {
											return type.Id !== model.METHODS_OF_PAYMENT.ACH;
										});
									}

									// If vendor is CC or VC only allow VC/CC
									if (
										vendor &&
										(vendor.MethodOfPaymentId === model.METHODS_OF_PAYMENT.CreditCard ||
											vendor.MethodOfPaymentId === model.METHODS_OF_PAYMENT.VirtualCard)
									) {
										model.methodOfPaymentTypes = _.filter(model.methodOfPaymentTypes, function (type) {
											return type.Id === vendor.MethodOfPaymentId;
										});
									}

									// set default if only option besides "select" - this will only be check.
									// Note.. if the vendor selected is EFT - then EFT will already be checked.
									if (model.methodOfPaymentTypes.length === 2) {
										$scope.newInvoice.MethodOfPaymentId = model.methodOfPaymentTypes[1].Id;
									}
								},
								loadEmployeeMethodOfPaymentTypes: function (employee) {
									model.methodOfPaymentTypes = angular.copy(model.backupMethodOfPaymentTypes);
									// remove EFT option for employees
									model.methodOfPaymentTypes = _.filter(model.methodOfPaymentTypes, function (type) {
										return type.Id !== model.METHODS_OF_PAYMENT.EFT;
									});

									var bRemove = false;
									if (!employee) {
										bRemove = true;
									}

									if (employee) {
										var empDDBank = employee.HasDirectDepositBank;

										if (!empDDBank) {
											bRemove = true;
										}
									}

									if (bRemove === true) {
										// no direct deposit banks setup, remove ACH option
										model.methodOfPaymentTypes = _.filter(model.methodOfPaymentTypes, function (type) {
											return type.Id !== model.METHODS_OF_PAYMENT.ACH;
										});
									}
								},
								validateAPSetup: function (methodOfPaymentId, showMessage) {
									if (showMessage === null || showMessage === undefined) {
										showMessage = true;
									}
									var message = null;
									if (model.apSetup && methodOfPaymentId === model.METHODS_OF_PAYMENT.ACH) {
										let apSetup = model.apSetup;
										if (apSetup.ACHSetupId === ACH_SETUP.GlobalLevel) {
											if (!apSetup.DDDebitAccountNumber || !apSetup.DDCreditAccountNumber) {
												message =
													'Payments by ACH cannot be made until the ACH Credit and Debit Accounts have been entered in Accounts Payable Setup.';
												if (showMessage) {
													dialogHelper.openMessageBox('ACH SETUP ERROR!', message, null, 'Warning');
												}
											}
										}
									}
									return message;
								},
								searchVendorbyName: function (value) {
									return vendorService.searchVendor(value, 1, $scope.vm.typeaheadLimit).then(_.partial(finishSearchVendors, model));

									function finishSearchVendors(model, response) {
										return response.data;
									}
								},
								searchEmployee: function (value) {
									let empNum = parseInt(value);
									if (isNaN(empNum)) {
										model.employeeFilter.name = value;
										model.employeeFilter.number = null;
									} else {
										model.employeeFilter.name = null;
										model.employeeFilter.number = value;
									}
									return employeeService.search(model.employeeFilter).then(_.partial(finishSearchEmployees, model));

									function finishSearchEmployees(model, response) {
										return response.data.employees;
									}
								},
								stateHelper: {
									getStateLabel: function (countryCode) {
										if (!countryCode || $scope.vm.states.length === 0) return 'State';

										var country = _.find($scope.vm.states, function (c) {
											return c.CountryCode === countryCode;
										});
										return country.LabelName;
									},
									filterStates: function (countryCode) {
										if (!countryCode || $scope.vm.states.length === 0) return;

										var country = _.find($scope.vm.states, function (c) {
											return c.CountryCode === countryCode;
										});
										return country.StateCodes;
									},
								},
								addVendor: function () {
									$uibModal
										.open({
											template: require('@ajs/templates/fund/payable/vendor-add-modal.html'),
											backdrop: 'static',
											keyboard: false,
											scope: $scope,
											controller: [
												'$scope',
												'$uibModalInstance',
												'vendorService',
												function ($scope, modalInstance, vendorService) {
													$scope.newVendor = {
														ShortName: model.nextVendorCode,
														VendorName: null,
														FederalTaxID: null,
														RemitAttn: null,
														RemitCountry: 'US',
														RemitAddress1: null,
														RemitAddress2: null,
														RemitCity: null,
														RemitState: null,
														RemitZip: null,
													};

													angular.extend($scope, {
														cancel: function () {
															model.errors = null;
															modalInstance.close();
														},
														save: function () {
															var isValid;
															// validate Zip
															$scope.vendorForm.remitZip.$setValidity('validZip', true);
															$scope.vendorForm.remitPostalCodeCA.$setValidity('validZip', true);
															$scope.vendorForm.remitPostalCodeOther.$setValidity('validZip', true);
															if (
																$scope.newVendor.RemitCountry &&
																$scope.newVendor.RemitCountry.length > 0 &&
																$scope.newVendor.RemitZip &&
																$scope.newVendor.RemitZip.length > 0
															) {
																isValid = isPostalCodeValid($scope.newVendor.RemitCountry, $scope.newVendor.RemitZip);
																switch ($scope.newVendor.RemitCountry) {
																	case 'US':
																		$scope.vendorForm.remitZip.$setValidity('validZip', isValid);
																		break;
																	case 'CA':
																		$scope.vendorForm.remitPostalCodeCA.$setValidity('validZip', isValid);
																		break;
																	default:
																		$scope.vendorForm.remitPostalCodeOther.$setValidity('validZip', isValid);
																		break;
																}
															}
															if (!$scope.vendorForm.$valid) return false;

															$scope.savingPromise = vendorService
																.addVendor($scope.newVendor)
																.then(function (response) {
																	if (response.data.isValid) {
																		modalInstance.close(response.data.vendorId);
																		loadNextVendorCode(model);
																	} else {
																		model.errors = response.data.errors;
																	}
																});
														},
													});
												},
											],
										})
										.result.then(function (vendorId) {
											if (vendorId) {
												$scope.getVendor(vendorId);
												$scope.invoiceForm.$setDirty();
												return;
											}
										});
								},
								getSite: getSite,
								validateInvoice: function () {
									var isValid = true;

									//if (!$scope.newInvoice.RemitCountry) {
									//    isValid = false;
									//}

									//if (!$scope.newInvoice.RemitState) {
									//    isValid = false;
									//}

									//if (!$scope.newInvoice.RemitZip) {
									//    isValid = false;
									//}

									if ($scope.newInvoice.InvoiceAccounts.length === 0) {
										model.validationErrors.push('At least one Account must be added.');
										isValid = false;
									}

									if ($scope.subTotal() === 0 && $scope.newInvoice.TotalTax > 0) {
										model.validationErrors.push('SubTotal must be greater than 0 to apply Taxes.');
										isValid = false;
									}

									if ($scope.newInvoice.PurchaseOrder && $scope.newInvoice.PurchaseOrder.EffectiveDT) {
										var poEffectiveDT = moment($scope.newInvoice.PurchaseOrder.EffectiveDT);
										if (moment($scope.newInvoice.InvoiceDT) < poEffectiveDT) {
											model.validationErrors.push(
												'Invoice Date cannot be earlier than the PO Order Date of ' +
													moment(poEffectiveDT).format('M/D/YYYY') +
													'.'
											);
											isValid = false;
										}
									}

									if (moment($scope.newInvoice.PostDT) < moment($scope.newInvoice.InvoiceDT)) {
										model.validationErrors.push('Post Date cannot be earlier than Invoice Date.');
										isValid = false;
									}

									if (moment($scope.newInvoice.DueDT) < moment($scope.newInvoice.InvoiceDT)) {
										model.validationErrors.push('Due Date cannot be earlier than Invoice Date.');
										isValid = false;
									}

									if (moment($scope.newInvoice.DueDT) < moment($scope.newInvoice.PostDT)) {
										model.validationErrors.push('Due Date cannot be earlier than Post Date.');
										isValid = false;
									}

									// If Account is PO Related - at least one line for any PO Related Account must have a value.
									// If Account is not PO Related - at least one line for the Account must have a value.
									let isPORelated = false;
									let AtLeastOnePOAccountsHasQty = false;
									_.each($scope.newInvoice.InvoiceAccounts, function (account) {
										if (account.IsFromPO) {
											isPORelated = true;
											// PO Related
											var poAcctHasQtyGreaterThanZero = _.countBy(account.InvoiceLines, function (line) {
												return line.Quantity > 0 || 0;
											});
											if (poAcctHasQtyGreaterThanZero.true) {
												AtLeastOnePOAccountsHasQty = true;
											}
										} else {
											// Non PO Related
											var regAcctHasQtyGreaterThanZero = _.countBy(account.InvoiceLines, function (line) {
												return line.Quantity > 0 || 0;
											});
											if (!regAcctHasQtyGreaterThanZero.true) {
												model.validationErrors.push(
													'Account # ' +
														account.Account.AccountNumber +
														' must have one or more lines with a quantity greater than zero.'
												);
												isValid = false;
											}
										}
										_.each(account.InvoiceLines, function (line) {
											if (line.Quantity * line.UnitCost > 9999999) {
												model.validationErrors.push(
													'Account # ' +
														account.Account.AccountNumber +
														', item description ' +
														line.Description +
														', calculated amount is too high. Reduce either the quantity or the unit cost.'
												);
												isValid = false;
											}
										});
									});

									if (isPORelated && AtLeastOnePOAccountsHasQty === false) {
										model.validationErrors.push(
											'At least one PO related Account must have a line where quantity is greater than zero.'
										);
										isValid = false;
									}

									var apSetupMsg = $scope.validateAPSetup($scope.newInvoice.MethodOfPaymentId, false);
									if (apSetupMsg) {
										model.validationErrors.push(apSetupMsg);
										isValid = false;
									}

									if (isValid !== true) {
										// Spawn error message
										dialogHelper.openMessageBox('Invoice Error!', null, model.validationErrors, 'Warning');
									}

									return isValid;
								},
								saveInvoice: function () {
									$scope.errors = null;
									$scope.closedMonthError = null;
									model.validationErrors = [];
									$scope.vm.closedMonth = null;

									if (!$scope.newInvoice.IsPayrollInvoice) {
										// validate RemitZip
										$scope.invoiceForm.zip.$setValidity('validZip', true);
										$scope.invoiceForm.postalCodeCA.$setValidity('validZip', true);
										$scope.invoiceForm.postalCodeOther.$setValidity('validZip', true);

										var isValid = true;
										if (($scope.newInvoice.RemitAddress1 || '').length > 0) {
											isValid = isPostalCodeValid($scope.newInvoice.RemitCountry, $scope.newInvoice.RemitZip);
										}

										switch ($scope.newInvoice.RemitCountry) {
											case 'US':
												$scope.invoiceForm.zip.$setValidity('validZip', isValid);
												break;
											case 'CA':
												$scope.invoiceForm.postalCodeCA.$setValidity('validZip', isValid);
												break;
											default:
												$scope.invoiceForm.postalCodeOther.$setValidity('validZip', isValid);
												break;
										}

										if (!$scope.validateInvoice() || !$scope.invoiceForm.$valid) return false;
									}

									model.busyMessage = BUSY_MESSAGE.Loading;
									$scope.busyPromise = unitService.getFiscalYearFromDate($scope.newInvoice.PostDT).then(function (response) {
										if (response.data.isValid) {
											if (response.data.fiscalYear !== $scope.vm.currentFY) {
												let title = 'Confirm Payment Date Outside of Current Fiscal Year';
												let msgDetail =
													'The Payment Date ' +
													moment($scope.newInvoice.PostDT).format('MM/DD/YYYY') +
													' is not in the current fiscal year. Do you want to save anyway?';
												dialogHelper.yesnoMessageBox(title, msgDetail, null, 'Question', yesFunction, noFunction);
											} else {
												return $scope.saveInvoiceForReal();
											}
										} else {
											return $scope.saveInvoiceForReal();
										}
									});

									function yesFunction() {
										$scope.saveInvoiceForReal();
									}

									function noFunction() {
										return;
									}
								},
								saveInvoiceForReal: function () {
									$scope.vm.closedMonth = {
										ActualMonthNumber: moment($scope.newInvoice.PostDT).month() + 1,
										ActualYear: moment($scope.newInvoice.PostDT).year(),
										ThirteenthMonth: false,
									};

									model.busyMessage = BUSY_MESSAGE.Loading;
									$scope.busyPromise = unitService
										.checkIfMonthsAreClosed($scope.vm.closedMonth)
										.then(_.partial(finishedCheckingClosedMonths, model));

									function finishedCheckingClosedMonths(model, response) {
										if (!response.data.isValid) {
											$scope.errors = response.data.errors;
											model.validationErrors = model.validationErrors.concat(response.data.errors);

											// Spawn error message
											dialogHelper.openMessageBox('Invoice Error!', null, model.validationErrors, 'Warning');
											return;
										}

										if (!response.data.isClosed) {
											if ($scope.newInvoice.Vendor) {
												$scope.newInvoice.VendorId = $scope.newInvoice.Vendor.Id;
											}
											if ($scope.newInvoice.Employee) {
												$scope.newInvoice.EmployeeId = $scope.newInvoice.Employee.Id;
											}

											// ensure vendor is not populated if employee has been selected...
											if ($scope.newInvoice.RemitTo === 'V') {
												$scope.newInvoice.EmployeeId = null;
												$scope.newInvoice.Employee = null;
											} else {
												$scope.newInvoice.VendorId = null;
												$scope.newInvoice.Vendor = null;
											}

											if ($scope.newInvoice.Site) {
												$scope.newInvoice.ShipTo = $scope.newInvoice.Site.SiteCode + ' ' + $scope.newInvoice.Site.SiteName;
											}

											if ($scope.newInvoice.Id) {
												model.busyMessage = BUSY_MESSAGE.Saving;
												if ($scope.newInvoice.ReadOnly === true && $scope.newInvoice.ReadOnlyEvent === false)
													$scope.busyPromise = invoiceService
														.updateInvoiceEvents($scope.newInvoice)
														.then(finishEditInvoice);
												else $scope.busyPromise = invoiceService.updateInvoice($scope.newInvoice).then(finishEditInvoice);
											} else {
												$scope.newInvoice.StatusId = INVOICE_STATUS.Unpaid;
												model.busyMessage = BUSY_MESSAGE.Saving;
												$scope.busyPromise = invoiceService.addInvoice($scope.newInvoice).then(finishEditInvoice);
											}
										} else {
											var monthYear = $scope.vm.closedMonth.ActualMonthNumber + '/' + $scope.vm.closedMonth.ActualYear;
											$scope.closedMonthError =
												'Post Date: ' +
												moment($scope.newInvoice.PostDT).format('l') +
												' falls within a month that has been closed or is not yet open.';

											model.validationErrors.push($scope.closedMonthError);

											// Spawn error message
											dialogHelper.openMessageBox('Invoice Closed Month Error!', null, model.validationErrors, 'Warning');
										}

										function finishEditInvoice(response) {
											if (response.data.isValid) {
												if ($scope.newInvoice.closePO === true) {
													purchaseOrderService.closePO($scope.newInvoice.PurchaseOrder.Id);
												}
												modalInstance.close('Added');
											} else {
												$scope.errors = response.data.errors;
												model.validationErrors = model.validationErrors.concat(response.data.errors);

												//Spawn error message
												dialogHelper.openMessageBox('Invoice Error!', null, model.validationErrors, 'Warning');
											}
										}
									}
								},
								updatePRorFMACHInvoice: function () {
									$scope.invoiceForm.$setSubmitted();
									if (!$scope.invoiceForm.$valid) return false;

									model.busyMessage = BUSY_MESSAGE.Saving;
									$scope.busyPromise = invoiceService.updatePRorFMACHInvoice($scope.newInvoice).then(finishPRorFMACHInvoice);

									function finishPRorFMACHInvoice(response) {
										if (response.data.isValid) {
											modalInstance.close('Added');
										} else {
											$scope.errors = response.data.errors;
											model.validationErrors = model.validationErrors.concat(response.data.errors);

											// Spawn error message
											dialogHelper.openMessageBox('Invoice Error!', null, model.validationErrors, 'Warning');
										}
									}
								},
							});
						},
					],
				})
				.result.then(function (added) {
					$scope.vm.newEditState = 'Done';
					if (added) {
						model.loadInvoices();
					}
				});
		}

		function sortby(model, propertyName) {
			model.filter.reverse = model.filter.propertyName === propertyName ? !model.filter.reverse : false;
			model.filter.propertyName = propertyName;
		}

		function showFilters(model) {
			$uibModal
				.open({
					template: require('@ajs/templates/fund/payable/invoice-filters-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						function ($scope, modalInstance) {
							$scope.newFilter = angular.copy($scope.vm.filter);

							angular.extend($scope, {
								clearAll: function () {
									$scope.newFilter.vendor = null;
									$scope.newFilter.site = model.filter.sites[0];
									$scope.newFilter.user = model.filter.users[0];
								},
								done: function () {
									if ($scope.filterForm.$valid) {
										modalInstance.close($scope.newFilter);
									}
								},
							});
						},
					],
				})
				.result.then(function (filter) {
					filter.modifiedByUserName = filter.user === model.filter.users[0] ? '' : filter.user;
					model.filter = filter;
				});
		}

		function filterOptionChanged(model) {
			if (model.filter.type === 'Invoice Number') {
				model.filter.fromDate = null;
				model.filter.toDate = null;
			} else {
				model.filter.invoiceNumberStartsWith = null;
				setDefaultDates(model);
			}
		}

		function setDefaultDates(model) {
			if (model.filter.statusId !== INVOICE_STATUS.Unpaid && model.filter.type !== 'Invoice Number') {
				if (model.filter.fromDate === null) {
					var now = new Date();
					model.filter.fromDate = moment(now.setMonth(now.getMonth() - 2)).toDate();
				}
				if (model.filter.toDate === null) {
					model.filter.toDate = new Date();
				}
			}
		}

		function loadInvoices(model) {
			model.busyMessage = BUSY_MESSAGE.Loading;
			$scope.busyPromise = invoiceService.searchInvoices(model.filter).then(_.partial(finishLoadingInvoices, model));

			function finishLoadingInvoices(model, response) {
				model.invoices = response.data;

				if (model.filter.statusId === INVOICE_STATUS.Paid) {
					// filter is Paid
					angular.forEach(model.invoices, function (invoice, key) {
						if (invoice.StatusId === INVOICE_STATUS.PartialPaid) {
							// invoice is Partial Paid, get paid amount from total of checks
							var unvoidedChecks = _.filter(invoice.InvoiceChecks, function (check) {
								return check.VoidDT === null;
							});
							invoice.paidAmount = _.reduce(
								unvoidedChecks,
								function (memo, check) {
									return memo + check.Amount;
								},
								0
							);
						} else {
							// invoice is Paid
							invoice.paidAmount = invoice.Total;
						}
					});
					// remove Partial Paid invoices with 0 paidAmount
					model.invoices = _.reject(model.invoices, function (invoice) {
						return invoice.StatusId === INVOICE_STATUS.PartialPaid && invoice.paidAmount === 0;
					});
				} else if (model.filter.statusId === INVOICE_STATUS.Unpaid) {
					// filter is Unpaid
					angular.forEach(model.invoices, function (invoice, key) {
						if (invoice.StatusId === INVOICE_STATUS.PartialPaid) {
							// invoice is Partial Paid, get unpaid amount from InvoiceAccount totals
							var unpaidInvoiceAccounts = _.filter(invoice.InvoiceAccounts, function (account) {
								return account.InvoiceCheckId === null;
							});
							invoice.unpaidAmount = _.reduce(
								unpaidInvoiceAccounts,
								function (memo, account) {
									return memo + account.Total;
								},
								0
							);
						} else {
							// invoice is Unpaid
							invoice.unpaidAmount = invoice.Total;
						}
					});
				}

				return angular.noop;
			}
		}

		function onSalesTaxDueInvoiceCreated(model, invoiceId) {
			loadInvoices(model);
			newEditInvoice(model, invoiceId, false, model.ReadOnly);
		}

		function onPaymentCardFileImported() {
			loadInvoices(model);
		}

		function loadStates(model) {
			return utilsService.getStates().then(_.partial(finishLoadingStates, model));

			function finishLoadingStates(model, response) {
				model.states = response.data.states;
				return angular.noop;
			}
		}

		function loadSites(model) {
			return siteService.getSites().then(_.partial(finishLoadingSites, model));

			function finishLoadingSites(model, response) {
				model.sites = response.data.sites;
				model.filter.sites = angular.copy(response.data.sites);
				model.filter.sites.splice(0, 0, { SiteName: 'All Sites', Id: 0 });
				model.filter.site = model.filter.sites[0];
				return angular.noop;
			}
		}

		function loadUsers(model) {
			return invoiceService.getModifiedByUserList().then(_.partial(finishLoadingUsers, model));

			function finishLoadingUsers(model, response) {
				model.filter.users = angular.copy(response.data);
				model.filter.users.splice(0, 0, 'All Users');
				model.filter.user = model.filter.users[0];
				return angular.noop;
			}
		}

		function loadInvoiceStatus(model) {
			return utilsService.getInvoiceStatus().then(_.partial(finishLoadingInvoiceStatus, model));

			function finishLoadingInvoiceStatus(model, response) {
				model.invoiceStatus = response.data;
				// remove Partial Paid
				model.invoiceStatus = _.filter(model.invoiceStatus, function (item) {
					return item.Id !== 2;
				});
				return angular.noop;
			}
		}

		function loadMethodOfPaymentTypes(model) {
			return utilsService.getMethodOfPaymentTypes().then(_.partial(finishLoadingMethodOfPaymentTypes, model));

			function finishLoadingMethodOfPaymentTypes(model, response) {
				unitService.getValue('EnabledVirtualCreditCards').then((enableResponse) => {
					const acceptablePaymentTypes = [METHODS_OF_PAYMENT.Check, METHODS_OF_PAYMENT.EFT, model.METHODS_OF_PAYMENT.ACH];

					if (enableResponse.data.value && enableResponse.data.value.toLowerCase() === 'true') {
						acceptablePaymentTypes.push(METHODS_OF_PAYMENT.CreditCard, METHODS_OF_PAYMENT.VirtualCard);
					}

					model.methodOfPaymentTypes = _.filter(response.data, function (type) {
						return acceptablePaymentTypes.includes(type.Id);
					});

					if (model.module === 'lsb') {
						// School Accounting, remove ACH option
						model.methodOfPaymentTypes = _.filter(model.methodOfPaymentTypes, function (type) {
							return type.Id !== model.METHODS_OF_PAYMENT.ACH;
						});
					}

					model.methodPaymentTypesCheckboxes = angular.copy(model.methodOfPaymentTypes);
					model.filter.paymentMethods = model.methodPaymentTypesCheckboxes.map((x) => x.Id);
					model.methodOfPaymentTypes.unshift({ Id: null, Description: 'Select' });
					model.backupMethodOfPaymentTypes = angular.copy(model.methodOfPaymentTypes);
					return angular.noop;
				});
			}
		}

		function loadAccountStructures(model) {
			return accountStructureService.getStructure().then(_.partial(finishLoadingAccountStructures, model));

			function finishLoadingAccountStructures(model, response) {
				let accountStructures = response.data.accountStructure;
				model.unifiedAccountMask = accountStructures.UnifiedAccountMask;
				// we will only show the mask if there is a unified mask
				//model.expenseAccountMask = accountStructures.ExpenseAccountMask;
				model.expenseAccountMask = model.unifiedAccountMask;
				return angular.noop;
			}
		}

		function loadUnitTaxRates(model) {
			return unitService.getUnit().then(_.partial(finishLoadingUnit, model));

			function finishLoadingUnit(model, response) {
				var unit = response.data.unit;
				model.unitTaxRates.stateTaxRateGoods = unit.StateTaxRateGoods;
				model.unitTaxRates.countyTaxRateGoods = unit.CountyTaxRateGoods;
				model.unitTaxRates.localTaxRateGoods = unit.LocalTaxRateGoods;
				model.unitTaxRates.stateTaxRateService = unit.StateTaxRateService;
				model.unitTaxRates.countyTaxRateService = unit.CountyTaxRateService;
				model.unitTaxRates.localTaxRateService = unit.LocalTaxRateService;
				model.unitTaxRates.stateTaxRateFood = unit.StateTaxRateFood;
				model.unitTaxRates.countyTaxRateFood = unit.CountyTaxRateFood;
				model.unitTaxRates.localTaxRateFood = unit.LocalTaxRateFood;
				return angular.noop;
			}
		}

		function loadAPSetup(model) {
			return apSetupService.getAPSetup().then(_.partial(finishLoadingAPSetup, model));

			function finishLoadingAPSetup(model, response) {
				model.apSetup = response.data.apSetup;
				return angular.noop;
			}
		}

		function loadEvents(model) {
			return eventService.getEvents({ Active: true }).then(_.partial(finishLoadingEvents, model));

			function finishLoadingEvents(model, response) {
				model.events = response.data.events;
				model.events.unshift({ Id: 0, EventCode: '', EventName: '' });
				return angular.noop;
			}
		}

		function loadCurrentFY(model) {
			return unitService.getCurrentFiscalYear().then(_.partial(finishLoadingCurrentFY, model));

			function finishLoadingCurrentFY(model, response) {
				model.currentFY = response.data.currentFiscalYear;
				return angular.noop;
			}
		}

		function searchVendorbyName(model, value) {
			return vendorService.searchVendor(value, 1, model.typeaheadLimit).then(_.partial(finishSearchVendors, model));

			function finishSearchVendors(model, response) {
				return response.data;
			}
		}

		function isPaymentMethodSelected(model, id) {
			return model.filter.paymentMethods.indexOf(id) > -1;
		}

		function selectPaymentMethod(model, id) {
			if (isPaymentMethodSelected(model, id)) {
				var methodIndex = model.filter.paymentMethods.indexOf(id);
				model.filter.paymentMethods.splice(methodIndex, 1);
			} else {
				model.filter.paymentMethods.push(id);
			}
		}

		function applyFilter(model, purchaseOrder) {
			if (model.filter.search || (model.filter.poFrom && model.filter.poTo)) {
				switch (model.filter.type) {
					case 'Site':
						return purchaseOrder.ShipTo.toLowerCase().indexOf(model.filter.search.toLowerCase()) !== -1;
					case 'Vendor':
						return purchaseOrder.OrderTo.toLowerCase().indexOf(model.filter.search.toLowerCase()) !== -1;
					case 'PO Number':
						return purchaseOrder.PONumber >= model.filter.poFrom && purchaseOrder.PONumber <= model.filter.poTo;
				}
			}
			return true;
		}

		function search(model) {
			if (model.filter.fromDate && model.filter.toDate) {
				model.loadPurchaseOrders();
			}
		}

		function deleteInvoice(model, invoiceId) {
			$uibModal
				.open({
					template: require('@ajs/templates/fund/payable/invoice-delete-modal.html'),
					backdrop: 'static',
					keyboard: false,
					scope: $scope,
					controller: [
						'$scope',
						'$uibModalInstance',
						function ($scope, modalInstance) {
							angular.extend($scope, {
								back: function () {
									modalInstance.close(false);
								},
								delete: function () {
									$scope.deletingPromise = invoiceService.deleteInvoice(invoiceId).then(_.partial(finishedDeletingInvoice, model));

									function finishedDeletingInvoice(model, response) {
										if (response.data.isValid) {
											modalInstance.close(true);
										} else {
											model.errors = response.data.errors;
											model.validationErrors = model.validationErrors.concat(response.data.errors);
											modalInstance.close(false);
										}
									}
								},
							});
						},
					],
				})
				.result.then(function (reload) {
					if (reload) {
						model.loadInvoices();
					}
				});
		}

		function loadTaxRateTypes(model) {
			return utilsService.getTaxRateTypes().then(_.partial(finishLoadingTaxRateTypes, model));

			function finishLoadingTaxRateTypes(model, response) {
				model.taxRateTypes = response.data;
			}
		}

		function loadTINTypes(model) {
			return utilsService.getTINTypes().then(_.partial(finishLoadingTINTypes, model));

			function finishLoadingTINTypes(model, response) {
				model.tinTypes = response.data;
			}
		}

		function loadVendor1099Boxes(model) {
			return utilsService.getVendor1099Boxes().then(_.partial(finishLoadingVendor1099Boxes, model));

			function finishLoadingVendor1099Boxes(model, response) {
				model.vendor1099Boxes = response.data;
			}
		}

		function loadNextVendorCode(model) {
			return unitService.getNextVendorCode().then(_.partial(finishLoadingNextVendorCode, model));

			function finishLoadingNextVendorCode(model, response) {
				model.nextVendorCode = response.data.data;
			}
		}

		return angular.extend(model, {
			loadStates: _.partial(loadStates, model),
			loadSites: _.partial(loadSites, model),
			loadUsers: _.partial(loadUsers, model),
			loadMethodOfPaymentTypes: _.partial(loadMethodOfPaymentTypes, model),
			loadTaxRateTypes: _.partial(loadTaxRateTypes, model),
			newEditInvoice: _.partial(newEditInvoice, model),
			filterOptionChanged: _.partial(filterOptionChanged, model),
			setDefaultDates: _.partial(setDefaultDates, model),
			loadInvoices: _.partial(loadInvoices, model),
			onSalesTaxDueInvoiceCreated: _.partial(onSalesTaxDueInvoiceCreated, model),
			onPaymentCardFileImported: _.partial(onPaymentCardFileImported, model),
			loadInvoiceStatus: _.partial(loadInvoiceStatus, model),
			applyFilter: _.partial(applyFilter, model),
			search: _.partial(search, model),
			deleteInvoice: _.partial(deleteInvoice, model),
			sortby: _.partial(sortby, model),
			showFilters: _.partial(showFilters, model),
			searchVendorbyName: _.partial(searchVendorbyName, model),
			isPaymentMethodSelected: _.partial(isPaymentMethodSelected, model),
			selectPaymentMethod: _.partial(selectPaymentMethod, model),
			loadAccountStructures: _.partial(loadAccountStructures, model),
			loadUnitTaxRates: _.partial(loadUnitTaxRates, model),
			loadAPSetup: _.partial(loadAPSetup, model),
			loadEvents: _.partial(loadEvents, model),
			loadCurrentFY: _.partial(loadCurrentFY, model),
			loadTINTypes: _.partial(loadTINTypes, model),
			loadVendor1099Boxes: _.partial(loadVendor1099Boxes, model),
			loadNextVendorCode: _.partial(loadNextVendorCode, model),
		});
	}
}
